import Reveal, { Eyebrow } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { REGIONS } from "@/data/site";

export default function OriginSection() {
  const { t, lang } = useLanguage();
  return (
    <section className="border-y hairline bg-coal/40 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-8 lg:grid-cols-2 lg:items-end">
          <Reveal>
            <Eyebrow>{t.origins.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl leading-tight text-cream sm:text-5xl">
              {t.origins.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-md text-base leading-relaxed text-cream/65 lg:ml-auto">
              {t.origins.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {REGIONS.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.1} className="h-full">
              <article
                data-testid={`origin-card-${r.id}`}
                className="group relative h-full overflow-hidden border hairline"
              >
                <img
                  src={r.image}
                  alt={`${r.name} tea region landscape`}
                  loading="lazy"
                  className="aspect-[3/4] h-full w-full object-cover transition-transform duration-[1.3s] ease-out group-hover:scale-[1.07]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-transparent" />
                <span className="absolute left-5 top-5 font-serif text-xl italic text-gold/90">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <h3 className="font-serif text-2xl text-cream transition-colors duration-300 group-hover:text-gold-light">
                    {r.name}
                  </h3>
                  <p className="mt-2.5 text-[13px] leading-relaxed text-cream/70">
                    {r.desc[lang]}
                  </p>
                </div>
                <span
                  className="absolute inset-0 border border-gold/0 transition-all duration-500 group-hover:border-gold/40"
                  aria-hidden="true"
                />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
